export default __webpack_public_path__ + "static/media/primecarephysio.6d2f0a0a.jpg";